import { React, useCallback, useEffect, useState } from 'react';
import Layout from '../Layout';
import { Flex, Spinner, Text } from '@chakra-ui/react';
import PricingCard from './PricingCard';
import { getAuthToken } from '../Helpers/script';
import { useAuth } from '../../Context/AuthContext';
import axios from 'axios';

const headerFontStyle = {
  color: '#1B2559',
  fontWeight: 700,
};

const headerSpanStyle = {
  color: '#4318FF',
};

const SubscriptionPage = () => {
  const [loading, setLoading] = useState(true);
  const [planType, setPlanType] = useState('freePlan');

  const { currentUser, setTopLevelError } = useAuth();
  const headerRenderer = useCallback(() => {
    return (
      <Flex direction="column" alignItems="center">
        <Text
          style={headerFontStyle}
          fontSize={{ base: '1.2rem', sm: '2rem', lg: '2.7rem' }}
        >
          Upgrade to <span style={headerSpanStyle}>Studywise PRO</span>
        </Text>
        {/* <Text>Lorem Ipsum</Text> */}
      </Flex>
    );
  }, []);

  const bodyRenderer = useCallback(() => {
    return (
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justifyContent="center"
        alignItems="center"
        gap="1.5rem"
      >
        {loading ? (
          <Spinner
            thickness="4px"
            speed="0.8s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        ) : (
          <>
            <PricingCard
              planId="freePlan"
              isCurrentPlan={planType === 'freePlan'}
            />
            <PricingCard
              planId="proPlan"
              isCurrentPlan={planType === 'proPlan'}
            />
          </>
        )}
      </Flex>
    );
  }, [loading, planType]);

  useEffect(() => {
    // retrieve subscription details

    const retrieve = async () => {
      if (!currentUser) return;
      try {
        setLoading(true);
        const token = await getAuthToken(currentUser);

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL ?? ''}/api/getUserCredits`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Handle success response here if necessary

        if (response.status === 200) {
          const { planType } = response.data;
          setPlanType(planType);
        }
      } catch (err) {
        console.log(err);
        setTopLevelError(
          "Couldn't retrieve subscription details. Please try again later."
        );
      }
      setLoading(false);
    };

    retrieve();
  }, [currentUser, setTopLevelError]);

  return (
    <Layout
      header={headerRenderer}
      body={bodyRenderer}
      hasGenericFooter={true}
    />
  );
};

export default SubscriptionPage;
